export default __webpack_public_path__ + "static/media/freelancer.0e5f6da0.svg";